if (!customElements.get('product-inventory-time')) {
  class ProductInventoryTime extends HTMLElement {
    constructor() {
      super();

      this.variants = this.querySelectorAll('[data-inventory-time-variant]');

      if (!this.variants.length) {
        return;
      }
    }
  
    connectedCallback() {
      document.addEventListener('variant:change', (event) => {
        const variant = event.detail.variant;

        this.variants.forEach((el) => {
          const variantId = el.getAttribute('data-inventory-time-variant');
          
          if (variant.id == variantId) {
            // this.checkVisibility(variant, el);
            el.classList.remove('hidden');

            return;
          }

          el.classList.add('hidden')
        });
      })
    }

    checkVisibility(variant, el) {
      const quantity = el.getAttribute('data-inventory-quantity');

      if (quantity <= 0) {
        el.classList.remove('hidden');

        return;
      }

      el.classList.add('hidden');
    }
  }
  
  customElements.define('product-inventory-time', ProductInventoryTime);
}